import { toast } from 'sonner'
import { api } from '../../../lib/api'

/**
 * Deschide un PDF servit de API, într-un tab nou.
 *
 * NU se poate pune pur și simplu `<a href="/api/...">`: tokenul de autentificare stă în memorie,
 * nu într-un cookie, deci o navigare obișnuită ajunge la server fără antetul `Authorization` și
 * primește 401. Prins în verificarea din browser — typecheck-ul n-avea cum.
 *
 * Se cere prin clientul API (care pune tokenul), se face un obiect-URL local și se deschide de
 * acolo. Același tipar ca la descărcarea documentelor.
 */
export async function deschidePdf(cale: string, numeFisier: string): Promise<void> {
  try {
    const r = await api.get(cale, { responseType: 'blob' })
    const url = URL.createObjectURL(r.data as Blob)
    const fereastra = window.open(url, '_blank')
    // Popup blocat (sau telefon): cade pe descărcare, ca omul să nu rămână fără document.
    if (!fereastra) {
      const a = document.createElement('a')
      a.href = url
      a.download = numeFisier
      a.click()
    }
    // Se eliberează după ce tabul a apucat să-l citească.
    setTimeout(() => URL.revokeObjectURL(url), 60_000)
  } catch {
    toast.error('Documentul nu s-a putut genera.')
  }
}
